import { useQuery } from '@apollo/client';

import { IOrderHistoryVariables } from '../useOrderHistory';
import type { IOrderDetails } from './orderDetail.interface';
import { orderDetailGql } from './gql';
export type { IOrderDetails } from './orderDetail.interface';

interface IOrderDetailsQuery {
  OrderDetail: IOrderDetails[];
}

interface IUseOrderDetails {
  variables: IOrderHistoryVariables;
}

export const useOrderDetails = ({ variables }: IUseOrderDetails) => {
  const { loading, data, error } = useQuery<IOrderDetailsQuery, IOrderHistoryVariables>(orderDetailGql, {
    context: {
      headers: {
        userFunctionKey: '9a1158154dfa42caddbd0694a4e9bdc8'
      }
    },
    variables
  });

  return { loadingOrderDetails: loading, orderDetails: data?.OrderDetail[0], errorOrderDetails: error };
};
